import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCampus, setAllCampuses } from '../redux/slices/meta';
import { resolveActiveCampus } from '../utils/activeCampus';
import useAuth from './useAuth';

// The active campus is resolved in utils/activeCampus — one rule shared with
// the auth bootstrap, which settles it before any page mounts and fires its
// first campus-scoped request. This hook mirrors that answer into redux (and
// localStorage, through the meta slice) and hands the switchers their list.
export const useCampus = () => {
  const dispatch = useDispatch();
  const activeCampus = useSelector((state) => state.meta.activeCampus);
  const allCampuses = useSelector((state) => state.meta.allCampuses);
  const { user } = useAuth();

  const userCampuses = user?.userAllCampus;
  const serverCampusId = user?.activeCampus?.id;

  useEffect(() => {
    if (!userCampuses) return;

    dispatch(setAllCampuses(userCampuses));

    const campus = resolveActiveCampus(user);
    if (campus) {
      dispatch(setActiveCampus(campus));
    }
    // user is read through the two values that can change the answer; taking
    // the object itself would re-run this on every auth state touch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userCampuses, serverCampusId]);

  return {
    activeCampus,
    allCampuses,
    setActiveCampus: (campus) => dispatch(setActiveCampus(campus)),
  };
};
